var path = 'infrastructure/directives/views/loading-wrapper.html';
var html = "<div> <div ng-show=!hasLoaded class=loading-wrapper-spinner> <spin active=busy.busy class=spin-static></spin> </div> <div ng-show=hasLoaded class=fade-in-when-loaded ng-class=\"{ 'has-loaded': hasLoaded }\"> <error-box error=busy.error></error-box> <div ng-show=!busy.error> <div ng-transclude></div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/views/loading-wrapper.html
// module id = 4922277350631598
// module chunks = 1